<div class="blueclrbg vh-100">
    <div class="tracker-main">
        <div class="container center" style="width:auto; max-width: 1000px">
            <h2 class="welcometxt pt-5" translate>lblWelcome</h2>
            <img id="landingPageLogo" class="headerImage filterlogo" style="max-width: 200px !important" alt="Logo" />
            <h1 class="bigtxt " translate>lblDigitalCheckIn</h1>
            <div class="logoright fnone bottom">
                <span translate>lblPoweredBy</span>
                <img class="brand" src="./../../../../assets/images/afx/header-logo.svg" alt="Logo" />
            </div>
        </div>
    </div>
</div>
